import moment from 'moment-timezone';

export const isDateInPast = date => {
	const dateNow = new Date();
	const dateToCheck = new Date(date);
	return dateNow >= dateToCheck;
};

export const isEventInProgress = (startTime, endTime) => {
	const currentTime = new Date();
	return (
		new Date(startTime) <= currentTime && currentTime <= new Date(endTime)
	);
};

export const isDayBeforeEvent = startTime => {
	const eventDay = new Date(startTime);
	let dayBeforeEvent = new Date(eventDay);
	dayBeforeEvent.setDate(eventDay.getDate() - 1);
	return isDateToday(dayBeforeEvent);
};

export const isDayOfEvent = startTime => {
	const eventDate = new Date(startTime);
	return isDateToday(eventDate);
};

export const isDateToday = dateObjectToCompare => {
	const today = new Date();
	return (
		today.getDate() === dateObjectToCompare.getDate() &&
		today.getMonth() === dateObjectToCompare.getMonth() &&
		today.getFullYear() === dateObjectToCompare.getFullYear()
	);
};

export const convertTimeToUtc = (time, date, timeZone) => {
	const timeToFormat = new Date(time);
	const dateToFormat = new Date(date);
	const year = dateToFormat.getFullYear();
	const month = dateToFormat.getMonth() + 1;
	const day = dateToFormat.getDate();
	const hours = timeToFormat.getHours();
	const minutes = timeToFormat.getMinutes();
	const dateInTimezoneSpecified = `${year}-${month}-${day} ${hours}:${minutes}`;
	const format = 'YYYY-MM-DD h:mm';
	const dateObjToConvert = moment.tz(
		dateInTimezoneSpecified,
		format,
		timeZone,
	);
	const utc = dateObjToConvert.utc().format();
	return utc;
};

export const transformFileToBase64 = file =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result.split(',', 2)[1]);
		reader.onerror = error => reject(error);
	});

export const getEventOrgImageUrl = event => {
	if (event) {
		return event.images?.orgImageUri || event.eventsOrganization?.imageUri;
	}
	return null;
};
